/* @flow */
import React from 'react';

import './styles/ReceiptFooter.scss';

const ReceiptFooter = React.createClass({
  render() {
    return (
      <tfoot className="ReceiptFooter">
        {this.props.children}
      </tfoot>
    );
  },
});

export default ReceiptFooter;



// WEBPACK FOOTER //
// ./src/payments/components/ReceiptFooter.jsx